import React, { Component } from 'react'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)

    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) {
      const constrainedClass = this.props.isConstrained
        ? 'u-sizeConstrained'
        : ''

      return (
        <div className={constrainedClass}>
          <div className="Grid Grid--alignMiddle u-flexJustifyBetween u-marginBottom4gu">
            <div className="Content u-paddingBottom0 u-sm-sizeFull">
              <h3 className="u-marginBottom3gu">{this.props.title}</h3>
              <div
                className="Notification Notification--withIcon Notification--alert u-block"
                role="alert"
              >
                <div className="Notification-content">{this.props.message}</div>
              </div>
            </div>
          </div>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
